module.exports = __webpack_public_path__ + "img/merchantServicesBanner1.e437eb45.png";